import { Box, Button, Chip, Tab, Tabs, Typography } from '@mui/material';
import CircularProgress from "@mui/material/CircularProgress";
import { AuthContext } from "context";
import { createMRTColumnHelper } from 'material-react-table';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MDAlert from "../../components/MDAlert";
import MDBox from "../../components/MDBox";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import showToast from "../../utils/toast";
import GenericTable from "../genericTable";
import StatusIndicator from "./StatusIndicator";


// Assuming GenericTable and other necessary components are imported

function ManagementSecuritySupplierAdmin() {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const {id,supplierName} = useParams();
  const [companyDocuments, setCompanyDocuments] = useState([]);
  const [personnelDocuments, setPersonnelDocuments] = useState([]);
  const [loadingSupplier, setLoadingSupplier] = useState(false);
  const [loadingPersonnel, setLoadingPersonnel] = useState(false);
  const companyColumnHelper = createMRTColumnHelper();
  const personnelColumnHelper = createMRTColumnHelper();
  const [personnelColumns, setpersonnelColumns]= useState([]);
  const initialPersonnelColumns = [
    personnelColumnHelper.accessor('action', {
      header: 'Azioni',
      size: 100,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        ( authContext?.hasAuth(`UPSERT_SECURITY_MANAGMENT`) && <Button
          variant="contained"
          size="small"
          onClick={() => navigate(`/security-document-approval/user/${row.original.id}/${row.original.name+"  ("+supplierName+")"}`)}
          sx={{
                marginTop: "10px", marginBottom: "30px", backgroundColor: '#514f4f',
                color: 'white!important',
                mb: 2,
                width: '120px',
                height: '40px',
                fontSize: '10px',
                display: 'flex',
                alignItems: 'center',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)',
                justifyContent: 'center',
                borderColor: 'black',
                gap: '8px',
                '&:hover': {
                  backgroundColor: '#514f4f',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)',
                  color: 'white!important',
                },
                '&:focus': {
                  backgroundColor: '#514f4f',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)',
                  color: 'white!important',
                },
                '&:active': {
                  backgroundColor: '#514f4f',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)',
                  color: 'white!important',
                }
              }}
        >
          Gestisci Documenti
        </Button>
        )
      ),
    }),
    personnelColumnHelper.accessor('name', {
      header: 'Operatore',
      size: 120,
    })
    /*personnelColumnHelper.accessor('last_name', {
  header: 'Cognome',
  size: 120,
}),*/
/*personnelColumnHelper.accessor('allow_access', {
  header: 'Abilita ingresso in cantiere',
  size: 120,
  enableColumnFilter: false,
  Cell: ({ cell }) => (
    ( authContext?.hasAuth(`UPSERT_SECURITY_MANAGMENT`) ?
        ( (cell.row?.original?.documents_required_not_uploaded == 0 && cell.row?.original?.documents_rejected == 0) &&
          <Checkbox
              checked={cell.row?.original?.allow_access}
              onChange={(event, value) => {

                handleCheckboxChange(cell.row.original.id, value);
              }}
              sx={{
                  transform: "scale(1.5)", // Ingrandisce la Checkbox di 1.5 volte
                  '& .MuiSvgIcon-root': { fontSize: 28 } // Ingrandisce l'icona all'interno della Checkbox
              }}
          />
        )
    :
    <Typography variant={"body2"}>
      {cell.getValue() ? 'Abilitato' : 'Disabilitato'}
    </Typography>
    )
  ),
}),
personnelColumnHelper.accessor('documents_required_uploaded', {
  header: 'Doc. Necessari Caricati',
  size: 100,
  enableColumnFilter: false,
  Cell: ({ cell }) => (
    <Typography >
      {cell.getValue()}
    </Typography>
  ),

}),
personnelColumnHelper.accessor('documents_required_not_uploaded', {
  header: 'Doc. Necessari Non Caricati',
  size: 100,
  enableColumnFilter: false,
  Cell: ({ cell }) => (
    <Typography color={parseInt(cell.getValue()) > 0 ? 'error' : 'inherit'}>
      {cell.getValue()}
    </Typography>
  ),
}),
personnelColumnHelper.accessor('documents_not_required_uploaded', {
  header: 'Doc. Opzionali Caricati',
  size: 100,
}),
personnelColumnHelper.accessor('documents_not_required_not_uploaded', {
  header: 'Doc. Opzionali Non Caricati',
  size: 100,
}),
personnelColumnHelper.accessor('documents_approved', {
  header: 'Doc. Approvati',
  enableColumnFilter: false,
  size: 100,
  Cell: ({ cell }) => (
    <Typography>
      {cell.getValue()}
    </Typography>
  ),
}),
personnelColumnHelper.accessor('documents_rejected', {
  header: 'Doc. Rifiutati',
  size: 100,
  enableColumnFilter: false,
  Cell: ({ cell }) => (
    <Typography color={parseInt(cell.getValue()) > 0 ? 'error' : 'inherit'}>
      {cell.getValue()}
    </Typography>
  ),
}),*/


  ]

  const handleSetNotification = (msg, severityType) => {
    showToast(msg, severityType);
  };

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  function fetchSupplierDocument(){
      setLoadingSupplier(true)
      let supplier_id = null
      if ( localStorage.getItem("supplier"))
        supplier_id = localStorage.getItem("supplier")
      else
        supplier_id = id

      apiService.get("/get-documents", {supplier_id: supplier_id,},{})
        .then((response) => {
          if (response) {
            setCompanyDocuments(response);
            setLoadingSupplier(false)
          }
        })
        .catch(error => {
          handleSetNotification(
              "Errore durante la chiamata al server, codice d'errore #08514262429906",
              "error"
          );
          setLoadingSupplier(false)
      })
  }

  function fetchPersonnelDocument(){
      setLoadingPersonnel(true)
      let supplier_id = null
      if ( localStorage.getItem("supplier"))
        supplier_id = localStorage.getItem("supplier")
      else
        supplier_id = id

      apiService.get("/get-documents", {supplier_id: supplier_id, is_summary: true},{})
        .then((response) => {
          if (response) {
            setPersonnelDocuments(response["userData"]);
            const new_columns = [...initialPersonnelColumns];
            const columns_to_add = response["columns"];
            columns_to_add.forEach(column => {
              const columnKey = Object.keys(column)[0]; // Prendi la chiave dell'oggetto (ID del documento)
              const columnName = column[columnKey]; // Prendi il valore (nome del documento)

              new_columns.push(
                personnelColumnHelper.accessor(columnKey, {
                  header: columnName,
                  size: 50,
                  enableColumnFilter: false,
                  Cell: ({ cell }) => (
                    <Typography>
                      <StatusIndicator status={cell.getValue()} />
                    </Typography>
                  ),
                })
              );
            });

            setpersonnelColumns([...new_columns]);
            setLoadingPersonnel(false)
          }
        })
        .catch(error => {
          handleSetNotification(
              "Errore durante la chiamata al server, codice d'errore #08514262429906",
              "error"
          );
          setLoadingPersonnel(false)
      })
  }

  useEffect(() => {
    // Simulating API calls
    //setCompanyDocuments(generateCompanyDocuments());
    if ( localStorage.getItem("supplier")) {
      fetchSupplierDocument()
      fetchPersonnelDocument()
    }

  }, []);

  useEffect(() => {
    if ( !localStorage.getItem("supplier") && id) {
      fetchSupplierDocument()
      fetchPersonnelDocument()
    }
  }, [id]);

  function handleCheckboxChange(id,value) {
    setPersonnelDocuments((prevPersonnelDocuments) => {
      return prevPersonnelDocuments.map((document) => {
        if (document.id === id) {
          return {
            ...document,
            allow_access: value,
          };
        }
        return document;
      });
    })

  }

  const companyColumns = [
    companyColumnHelper.accessor('label', {
      header: 'Nome',
      size: 150,
    }),
    companyColumnHelper.accessor('status', {
      header: 'Stato',
      size: 120,
      Cell: ({ cell }) => (
        <Chip
          label={getStatusName(cell.getValue())}
          color={getStatusColor(cell.getValue(),cell.row.original.required)}
          size="medium"
          sx={{ fontWeight: 'medium' }}
        />
      ),
    }),
    companyColumnHelper.accessor('required', {
      header: 'Richiesto',
      size: 100,
      Cell: ({ cell }) => (
        <Typography variant="body2">
          {cell.getValue() ? 'Necessario' : 'Opzionale'}
        </Typography>
      ),
    }),
    companyColumnHelper.accessor('additionalInformation', {
      header: 'Informazioni Aggiuntive',
      size: 250,
      Cell: ({ cell }) => (
        <Box>
          {cell.getValue().map((info, index) => (
            <Typography key={index} variant="body2">
              {info.label}: {info.value || 'N/A'}
            </Typography>
          ))}
        </Box>
      ),
    }),
    companyColumnHelper.accessor('url', {
      header: 'Azioni',
      size: 100,
      Cell: ({ cell }) => (
        cell.row.original.status !== 'toUpload' &&
        <Button
          variant="outlined"
          size="small"
          onClick={() => window.open(cell.getValue(), '_blank')}
          sx={{
                marginTop: "10px", marginBottom: "30px", backgroundColor: '#514f4f',
                color: 'white!important',
                mb: 2,
                width: '80px',
                height: '25px',
                fontSize: '10px',
                display: 'flex',
                alignItems: 'center',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)',
                justifyContent: 'center',
                borderColor: 'black',
                gap: '8px',
                '&:hover': {
                  backgroundColor: '#514f4f',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)',
                  color: 'white!important',
                },
                '&:focus': {
                  backgroundColor: '#514f4f',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)',
                  color: 'white!important',
                },
                '&:active': {
                  backgroundColor: '#514f4f',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)',
                  color: 'white!important',
                }
              }}
        >
          Visualizza
        </Button>
      ),
    }),
  ];

  return (
    <>
    <DashboardLayout>
      { authContext?.hasAuth(`VIEW_SECURITY_MANAGMENT`) ?
        <>
          <DashboardNavbar></DashboardNavbar>
          <center>
            <Typography variant="h3" gutterBottom sx={{ mt: 3, mb: 2 }}>
                  DOCUMENTI DI {supplierName.toUpperCase()}
            </Typography>
            <Button
                      onClick={() => navigate('/manage-security-area-supplier-admin/')}
                      type="submit" variant="contained" component="span"
                      sx={{
                         backgroundColor: '#514f4f',
                              color: 'white!important',
                              mb: 2,
                              width: '220px',
                              height: '50px',
                              fontSize: '16px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                      }}
                    >
                      Indietro
                    </Button>
          </center>
          <Tabs value={activeTab} onChange={handleChange} centered>
                <Tab label="Documenti aziendali"/>
                <Tab label="Documenti operatori"/>
          </Tabs>
          <TabPanel value={activeTab} index={0}>
             <Box sx={{ p: 3, width: '100%' }}>
                <Box sx={{mb: 4}}>
                  <center>
                    <Typography variant="h5" gutterBottom>
                      DOCUMENTI AZIENDALI
                    </Typography>
                    { (authContext?.hasAuth(`UPSERT_SECURITY_MANAGMENT`) && !loadingSupplier) &&<Button
                      variant="contained"
                      color="primary"
                      onClick={() => navigate(`/security-document-approval/supplier/`+id+"/"+supplierName.toUpperCase())}
                      sx={{
                        marginTop: "10px", marginBottom: "30px", backgroundColor: '#514f4f',
                        color: 'white!important',
                        mb: 2,
                        width: '220px',
                        height: '50px',
                        fontSize: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)',
                        justifyContent: 'center',
                        gap: '8px',
                        '&:hover': {
                          backgroundColor: '#514f4f',
                          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)',
                          color: 'white!important',
                        },
                        '&:focus': {
                          backgroundColor: '#514f4f',
                          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)',
                          color: 'white!important',
                        },
                        '&:active': {
                          backgroundColor: '#514f4f',
                          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)',
                          color: 'white!important',
                        }
                      }}
                    >
                      Gestisci Documenti
                    </Button>}
                    {loadingSupplier &&  <CircularProgress size={120} sx={{marginTop: "250px", color: "#2b84ea"}}/> }
                  </center>
                  { !loadingSupplier &&
                    <GenericTable
                      data={companyDocuments}
                      columns={companyColumns}
                      enableRowSelection={false}
                    />
                  }
                </Box>
             </Box>
          </TabPanel>
          <TabPanel value={activeTab} index={1}>
            <Box sx={{ p: 3, width: '100%' }}>
                <MDBox style={{width: "100%", marginTop: "20px"}}>
                <center>
                  <Typography variant="h5" gutterBottom>
                    DOCUMENTI PERSONALE
                  </Typography>
                </center>
                 {(!loadingPersonnel && personnelColumns.length > 0) ? (
                    <GenericTable
                      key={personnelColumns?.length}
                      data={personnelDocuments}
                      columns={personnelColumns}
                      enableRowSelection={false}
                    />
                  ) : (
                    <center>
                      <CircularProgress size={120} sx={{ marginTop: "250px", color: "#2b84ea" }} />
                    </center>
                  )}
                </MDBox>
            </Box>
          </TabPanel>



           </>
        :
        <MDBox sx={{ mt: 8 }}>
              <MDAlert color="error">
                Non hai i permessi per visualizzare questa pagina.
              </MDAlert>
        </MDBox>

      }
    </DashboardLayout>
    </>
  );
}

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
        {value === index && (
                <Box sx={{p: 3}}>
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

// Helper functions

function getStatusColor(status, required) {
  switch (status.toLowerCase()) {
    case 'approved':
      return 'success';
    case 'rejecteddone':
      return 'info';
    case 'toapprove':
      return 'warning';
    case 'toupload':
      if (required ) {
        return 'error';
      }
      return 'secondary';
    case 'rejected':
      return 'error';
    default:
      return 'default';
  }
}

function getStatusName(status) {
  switch (status.toLowerCase()) {
    case 'approved':
      return 'Approvato';
    case 'rejecteddone':
      return 'Rettificato';
    case 'toapprove':
      return 'In attesa';
    case 'toupload':
      return "Da caricare"
    case 'rejected':
      return 'Da rettificare';
    default:
      return 'default';
  }
}

export default ManagementSecuritySupplierAdmin;
